import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'
import type { FilterOperator } from '@/types/api'
import type { OperatorOption } from './filter-types'

interface OperatorSelectProps {
  value: FilterOperator
  options: OperatorOption[]
  onChange: (value: FilterOperator) => void
  label?: string
  className?: string
}

export function OperatorSelect({
  value,
  options,
  onChange,
  label,
  className,
}: OperatorSelectProps) {
  const selectedOption = options.find((opt) => opt.value === value)

  return (
    <Select value={value} onValueChange={(v) => onChange(v as FilterOperator)}>
      <SelectTrigger
        className={cn(
          'border-none bg-transparent px-0 shadow-none font-univers text-sm text-primary hover:bg-transparent focus:ring-0 [&>svg]:text-primary',
          className
        )}
      >
        <span className="flex items-center">
          {label && <span className="text-primary">[{label}]&nbsp;</span>}
          <SelectValue>
            {selectedOption?.label.toLowerCase() ?? 'select...'}
          </SelectValue>
        </span>
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            className="font-univers"
          >
            {option.label.toLowerCase()}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
